export * from './db/defaults';
export * from './db';
export * from './media';
export * from './chat';
export * from './fs';
import {getWT, startUpMediaSharing} from './media';
import {writeItem, getUserData, getById} from './db';
declare global {
  var ethers: any;
  var ethereum: any;
  var publicSocketCallback: any;
  var newMediaCallback: any;
  var setupPartyView: any;
  var playMediaLink: any;
  var playMesh: any;
  var mediaClient: any;
  var windowClosedCallback: any;
  // var localStorage: any;
  var showOpenFilePicker: any;
}
export {evolu, createDBConn} from './db';
import * as ExpoDevice from 'expo-device';

import {colors, domain, userDocKey} from './db/defaults';

import {CurrentUserData, Device} from '../types';
import {Platform} from 'react-native';
import {doInitialMigration} from './db/migration';

const apiURL = `${domain}api/v1/`;

export let UserData: CurrentUserData = {
  user: {
    id: 'test',
    name: 'test',
  },
  isEditingFolder: {},
  colors,
  searchItems: [],
  currentFolderIds: {},
};

export const initUserData = async () => {
  try {
    UserData.user = await doInitialMigration(writeItem, getUserData);
    const userAgent =
      ExpoDevice.designName?.replace(/[^\w\s]/gi, '') ||
      'unknown_agent';
    const os = ExpoDevice.osName || 'unknown_os';
    const browserName = ExpoDevice.brand || 'web';
    console.info('browserName', browserName);
    const deviceId = userAgent + os + browserName;
    // console.info('deviceId', deviceId)
    const device = (await getById(deviceId)) as Device;
    // console.info('device', device)
    if (!device || !device.manufacturer) {
      const ndevice: Device = {
        id: deviceId,
        manufacturer: browserName,
        isDevice: true,
        userAgent,
        createdAt: new Date().valueOf(),
        model: browserName,
        os,
        platform: Platform.OS,
      };
      console.info(ndevice);
      await writeItem(ndevice);
    }
    console.info('initUserData', UserData);
    if (Platform.OS === 'web') {
      // startUpMediaSharing();
    }
  } catch (err) {
    console.error('initUserData Error', err);
  }
};

export const publicPartyPref = () => {};
export const deleteById = (id: string) => {};
export const setOpenItem = () => {};
export const removeFile = () => {};
export const downloadFile = () => {};

export const getUnreadMessages = () => {};
export const extractMedia = async (link: string) => {
  const media = await getWT(link);
  console.info('onMedia', media);
  return {
    url: media.magnetURI,
    title: media.name,
    originalId: media.infoHash,
    id: media.infoHash,
    filename: media.files[0].name,
    extractor: 'wt',
    isFolder:
      media.files && media.files?.length > -1 ? true : undefined,
    files:
      media.files && media.files?.length > -1
        ? media.files
        : undefined,
  };
};
